import { FormattedText } from "@tm/static";
import { Fragment, useMemo } from "react";
import type {
  CancelPolicyBreakupItem,
  CancelPolicyOrderSummaryData,
} from "../types";
import {
  cardBodyLabelStyle,
  cardBodyValueStyle,
  cardHeaderTitleStyle,
  cardSubtitleStyle,
  LabelCell,
  OrderItemRow,
  OrderItemsSection,
  OrderSummaryHeader,
  StepCard,
  StepCardDivider,
} from "./CancelPolicyStepCards.style";

const OrderItem = ({ item }: { item: CancelPolicyBreakupItem }) => (
  <OrderItemRow>
    <LabelCell>
      <FormattedText value={item.label} baseStyle={cardBodyLabelStyle} />
    </LabelCell>
    <FormattedText value={item.value} baseStyle={cardBodyValueStyle} />
  </OrderItemRow>
);

export const CancelPolicyOrderSummary = ({
  header,
  sections,
}: CancelPolicyOrderSummaryData) => {
  const visibleSections = useMemo(
    () => sections?.filter((section) => section?.items?.length) ?? [],
    [sections]
  );

  if (!header) {
    return null;
  }

  return (
    <StepCard>
      {header.title || header.subTitle ? (
        <OrderSummaryHeader>
          {header.title ? (
            <FormattedText
              value={header.title}
              baseStyle={cardHeaderTitleStyle}
            />
          ) : null}
          {header.subTitle ? (
            <FormattedText
              value={header.subTitle}
              baseStyle={cardSubtitleStyle}
            />
          ) : null}
        </OrderSummaryHeader>
      ) : null}

      {visibleSections.map((section, sectionIndex) => (
        <Fragment key={`section-${sectionIndex}`}>
          {sectionIndex > 0 ? <StepCardDivider /> : null}
          <OrderItemsSection>
            {section.items?.map((item, itemIndex) => (
              <OrderItem
                key={`item-${sectionIndex}-${itemIndex}`}
                item={item}
              />
            ))}
          </OrderItemsSection>
        </Fragment>
      ))}
    </StepCard>
  );
};

export default CancelPolicyOrderSummary;
